<template>
  <div :style="$cmsStyles('c_145b08088feb')" class="media-container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="media-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_145b08088feb', 'f_0001', true)" class="banner-wrapper"></div>
        <div class="common-content-wrapper content-wrapper">
          <div v-show="$cms('c_145b08088feb', 'f_0002', true)" class="box-1">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_145b08088feb', 'f_0003', "品牌介绍") }}</h2>
              <div class="box-header-desc">{{ $cms('c_145b08088feb', 'f_0004', "Brand  Introduction") }}</div>
            </div>
            <div class="box-content">
              <div class="desc">{{ $cms('c_145b08088feb', 'f_0005', "露小白品牌是一家集研、产、销于一体的创新国货清洁日化品牌，专注研发生产和销售家庭清洁产品，聚焦于家庭环境清洁产品及衣物清洁用品。") }}<br />{{ $cms('c_145b08088feb', 'f_0006', "目前露小白品牌产品包括洗衣液、内衣洗衣液、洗洁精、油污净等多个核心品类。其中，深层洁净洗衣液与重油污净稳居快手电商快分销爆款榜TOP1！") }}<br />{{ $cms('c_145b08088feb', 'f_0007', "露小白致力于为用户提供更高效、更便捷、更优质的一站式家庭清洁解决方案，打造中国人自己的家庭强效清洁好帮手。") }}</div>
            </div>
          </div>


          <div v-show="$cms('c_145b08088feb', 'f_0008', true)" class="box-3">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_145b08088feb', 'f_0009', "品牌定位") }}</h2>
              <div class="box-header-desc">{{ $cms('c_145b08088feb', 'f_0010', "Brand Positioning") }}</div>
            </div>
            <div class="box-content">
             
            </div>
          </div>

          <div v-show="$cms('c_145b08088feb', 'f_0011', true)" class="box-7">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_145b08088feb', 'f_0012', "产品介绍") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_145b08088feb', 'f_0013', "Product Introduction") }}</div>
              <div class="box-header-desc">{{ $cms('c_145b08088feb', 'f_0014', "爱干净 就用露小白") }}</div>
            </div>
            <div class="box-content">
              <div class="band-btns" role="group" aria-label="产品大系列">
                <button class="btn" type="button" v-for="tab in productTabs" :key="tab.value"
                  :class="{ active: selectedCategory === tab.value }" :aria-pressed="selectedCategory === tab.value"
                  @click="selectedCategory = tab.value">{{ tab.label }}</button>
              </div>
              <div class="band-group-list">
                <section class="group-item" v-for="(item, groupIndex) in visibleGroups" :key="groupIndex">
                  <h3 class="group-title">{{ item.type }}</h3>
                  <section class="series-item" v-for="(series, seriesIndex) in item.series" :key="seriesIndex">
                    <h4 v-if="series.name" class="series-title">{{ series.name }}</h4>
                    <div class="group-item-list">
                      <div class="item" v-for="(listItem, productIndex) in series.list" :key="productIndex">
                        <div class="item-visual">
                          <div class="item-img">
                            <img :src="listItem.img" loading="lazy" :alt="listItem.name">
                          </div>
                        </div>
                        <div class="item-info">
                          <div class="item-name">
                            <span class="item-name-line" v-for="(line, lineIndex) in productNameLines(listItem.name)" :key="lineIndex">{{ line }}</span>
                          </div>
                          <div v-if="listItem.desc" class="item-desc">{{ listItem.desc }}</div>
                        </div>
                      </div>
                    </div>
                  </section>
                </section>
              </div>
            </div>
          </div>
          <BrandCooperationBox />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue';
import BrandCooperationBox from '@/components/brand/BrandCooperationBox.vue';

export default {
  components: {
    ToolsBar,
    BrandCooperationBox,
  },
  head() { return this.$cmsHead('c_145b08088feb', {
    title: '露小白-家庭强效清洁好帮手|洗衣液|洗洁精|清洁用品|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '露小白,家庭清洁,洗衣液,洗洁精,重油污净,内衣洗衣液,清洁用品,日化用品,家庭清洁,快手,抖音,视频号,小红书,魔筷科技',
      },
      {
        name: 'Description',
        content:
          '露小白是集研、产、销于一体的创新国货清洁日化品牌，专注家庭清洁产品研发。深层洁净洗衣液与重油污净稳居快手电商爆款榜TOP1，致力于为用户提供更高效、更便捷的一站式家庭清洁解决方案。',
      },
    ],
  }); },
  data() {
    return {
      selectedCategory: -1,
      brandBtns: this.$cms('c_145b08088feb', 'f_0015', ['全部产品']),
      brandGroupList: this.$cms('c_145b08088feb', 'f_0016', [{"type":"衣物清洁","series":[{"name":"净护系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/fbb77f1b-d38c-49e8-8a20-224476783ac5.jpg","name":"氨基酸内衣洗衣液","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/94e8234d-c634-493b-be6f-0688b13dc68f.jpg","name":"白衣去渍漂白液","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/142a3b8f-3fe2-4962-87bd-10d7b478c7e0.jpg","name":"多酶衣物爆炸盐","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/625a3399-7426-4c64-af21-e09b24f16f3a.jpg","name":"活氧酵素内衣洗衣液","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/570ec0b5-2048-4ca3-a8e1-4fbd23760898.jpg","name":"酵素香氛洗衣液（晨光橙花与晚香玉）","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/b288bf10-5eda-4d64-8538-a36005ca0337.jpg","name":"酵素香氛洗衣液（晴沙渡芜与檀蜜漫衣）","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/4eaa4f55-65c8-4b37-95b8-9ecb82b9ab77.jpg","name":"酵素香氛洗衣液（午夜幻境与紫罗兰）","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/5027b943-a8f1-4f9a-b983-27912e920481.jpg","name":"清渍彩漂液","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/96a8a1be-72b7-471d-b05d-15471ff5358b.jpg","name":"天然香氛洗衣皂液（浮光橘彩与玫瑰）","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/417cc8d4-a0e7-487b-aa20-b01e3d5a461f.jpg","name":"香氛衣物柔顺","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/a31c6a38-57f4-4498-b827-7b238b35696a.jpg","name":"衣领袖口酵素预洗剂","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/007c9bb3-7f08-42e4-8d4f-aa56b906faaa.jpg","name":"抑菌柔护内衣洗衣液","desc":""}]},{"name":"香露公主系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/2ae06eef-232a-4d3a-b7ba-1fc378f745c8.jpg","name":"香氛衣物柔顺剂","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/5478ed72-a017-453c-a595-afa2fd366629.jpg","name":"香露公主香氛护色洗衣液","desc":""}]},{"name":"其他系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/ce7743f8-f914-45c6-acc8-a8d9fbd0021f.jpg","name":"除菌内衣洗衣液","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/ea33a0c2-f236-4e73-8e2b-5b7ad6cca041.jpg","name":"花漾酵素香氛洗衣液","desc":""}]}]},{"type":"全屋清洁","series":[{"name":"净护系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/0365c131-9bd6-4509-af96-47c4ee271c5c.jpg","name":"冰箱除味剂","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/6bd79639-0346-46cb-af82-649d0079dd38.jpg","name":"厕所洁厕液","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/1d7f24f5-8d5e-4e77-9657-205cb413839e.jpg","name":"厨房油烟机重油污净","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/5e2565c8-67e0-4298-bab9-d01e809e1b93.jpg","name":"地板清洁剂","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/23ae0293-2b8d-4db6-9c5a-5248a99c442f.jpg","name":"管道疏通剂","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/64da3be2-0b9a-47b9-a525-10a0a9eec403.jpg","name":"酵素果蔬餐具净","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/d809a749-e82c-498c-ab0b-8a47e2851bd1.jpg","name":"香氛油污净喷雾","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/565da51f-6c93-4230-84a3-11070559001c.jpg","name":"盐洁酵素餐具净","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/9b2e227e-41b2-46ab-b7cd-ebd4d479e3c7.jpg","name":"浴室清洁剂","desc":""}]},{"name":"香露公主系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/81cb7c92-db5a-438a-8e8d-4cf5535eb21d.jpg","name":"厨房重油污净","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/9a997ade-5dbe-4303-80b7-413a287fbc9c.jpg","name":"多功能清洁剂","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/f1c148e4-1370-431f-8110-94e42e659756.jpg","name":"果蔬餐具净","desc":""}]},{"name":"其他系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/92b91c15-3b0c-4aa2-be6c-8b0ce34136d0.jpg","name":"多功能清洁喷雾","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/f27792a8-dcdb-43ed-85a7-b816378d708e.jpg","name":"重油污净","desc":""}]}]}]),
    }
  },
  computed: {
    productGroups() {
      // Published legacy lists remain readable until their draft is upgraded and published.
      return this.brandGroupList.map(group => ({
        type: group.type,
        series: Array.isArray(group.series) ? group.series : [{ name: '', list: group.list || [] }],
      }));
    },
    productTabs() {
      return [{ label: this.brandBtns[0] || '全部产品', value: -1 }].concat(
        this.productGroups.map((group, index) => ({ label: group.type, value: index }))
      );
    },
    visibleGroups() {
      return this.selectedCategory === -1 ? this.productGroups : this.productGroups.filter((group, index) => index === this.selectedCategory);
    },
  },
  mounted() {
    // this.initFullpage()
    this.$refs.toolsBar.show()
  },
  methods: {
    productNameLines(name) {
      const text = String(name || '');
      const index = text.search(/[（(]/);
      return index > 0 ? [text.slice(0, index).trim(), text.slice(index)] : [text];
    },
  },
}
</script>

<style lang="less" scoped>
@import "../../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-image: var(--cms-c_145b08088feb-f_0017, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250910172245410000552.17574961652571422.jpg?x-oss-process=image/quality,Q_80"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
    }
  }
  .content-wrapper {
    .box-1 {
      background: #FFF;
      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 60);
        .pxToVw(width, 1440);
        .pxToVw(height, 754);
        background-image: var(--cms-c_145b08088feb-f_0018, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250915191902110000937.17579351419654685.png"));
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
        position: relative;
        .pxToVw(padding-top, 200);
        .pxToVw(padding-left, 86);
        .desc {
          .pxToVw(width, 620);
          font-weight: 400;
          .pxToVw(font-size, 22);
          .pxToVw(line-height, 40);
          color: #666666;
        }
      }
    }


    .box-3 {
      background: #FFF;
      .box-content {
        .pxToVw(margin-top, 80);
        .pxToVw(width, 1920);
        .pxToVw(height, 1080);
        background-image: var(--cms-c_145b08088feb-f_0019, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250910171931670000629.17574959714865805.jpg?x-oss-process=image/quality,Q_80"));
        background-size: cover;
        background-repeat: no-repeat;
      }
    }

    .box-7 {
      background: #fff;
      .pxToVw(padding-bottom, 80);
      .box-header-title {
        .pxToVw(margin-bottom, 12);
        &::after { .pxToVw(top, 90); }
      }
      .band-btns {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0 auto;
        .pxToVw(width, 1440);
        .pxToVw(gap, 40);
        .pxToVw(padding-top, 80);
        .pxToVw(padding-bottom, 60);
        .btn {
          .pxToVw(min-width, 210);
          .pxToVw(min-height, 48);
          .pxToVw(border-radius, 30);
          .pxToVw(font-size, 18);
          .pxToVw(padding-left, 24);
          .pxToVw(padding-right, 24);
          line-height: 1.5;
          background: #fff;
          font-family: inherit;
          color: #333;
          border: 1px solid #bbb;
          cursor: pointer;
          &.active {
            background: linear-gradient(90deg, #ff6600 0%, #fc4440 100%);
            border-color: transparent;
            color: #fff;
          }
          &:focus-visible { outline: 2px solid #ff6600; outline-offset: 4px; }
        }
      }
      .band-group-list {
        .pxToVw(width, 1440);
        margin: 0 auto;
      }
      .group-item + .group-item { .pxToVw(margin-top, 60); }
      .group-title {
        margin: 0;
        .pxToVw(margin-bottom, 32);
        .pxToVw(font-size, 30);
        line-height: 1.4;
        font-weight: 600;
        color: #333;
      }
      .series-item + .series-item { .pxToVw(margin-top, 32); }
      .series-title {
        margin: 0;
        .pxToVw(margin-bottom, 24);
        .pxToVw(font-size, 24);
        line-height: 1.5;
        font-weight: 400;
        color: #666;
        &::before { content: '· '; }
      }
      .group-item-list {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        .pxToVw(row-gap, 28);
      }
      .item { min-width: 0; }
      .item-visual {
        .pxToVw(height, 260);
        background: #fbfbfb;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .item-img {
        .pxToVw(width, 180);
        .pxToVw(height, 180);
        border: 1px solid #ccc;
        border-radius: 50%;
        background: #fff;
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        img { display: block; width: 80%; height: 80%; object-fit: contain; }
      }
      .item-info {
        .pxToVw(padding-top, 20);
        .pxToVw(padding-left, 18);
        .pxToVw(padding-right, 18);
        text-align: center;
        overflow-wrap: anywhere;
      }
      .item-name-line { display: block; }
      .item-name { .pxToVw(font-size, 24); line-height: 1.5; font-weight: 600; color: #333; }
      .item-desc { .pxToVw(font-size, 18); .pxToVw(margin-top, 6); line-height: 1.5; color: #888; }
    }

  }
}
</style>
